import { type FC, useMemo } from 'react';
import { useNavigate } from 'react-router';
import dayjs from 'dayjs';
import { TObjectJob } from 'types/objectJob.type';
import { Button, Icon, Typography } from '@timeedit/ui-components';
import { useJobBulkEditProps } from '../../../BulkEditStartJobButton';
import { JobStatusMessage, JobStatusTag } from '../../JobStatus';
import { jobOperationTypeLabels } from '../../constants/job.constant';
import './JobDetailHeader.scss';

const { Text, Title } = Typography;

type Props = {
  job: TObjectJob;
  newOperationButton: React.ReactNode;
};

const JobDetailHeader: FC<Props> = (props) => {
  const bulkEditProps = useJobBulkEditProps(props.job);
  const { jobSummary } = bulkEditProps;

  const formattedTime = useMemo(() => {
    const date = props.job.queuedAt ? dayjs(props.job.queuedAt) : undefined;
    if (!date || !date.isValid()) return 'N/A';

    return date.format('YYYY-MM-DD HH:mm:ss');
  }, [props.job]);

  const title = jobOperationTypeLabels[props.job.operationType];

  const navigate = useNavigate();

  return (
    <div className="job-detail-header">
      <div className="job-detail-header__content">
        <div>
          <Button
            type="text"
            className="job-detail-header__back-button"
            onClick={() => navigate(-1)}
          >
            <Icon id="ArrowLeftOutlined" alt="Back" size={18} />
          </Button>
        </div>
        <div>
          <Title level={3}>{title}</Title>
          <div className="job-detail-header__properties">
            <div className="job-detail-header__property">
              <Text>Start time:</Text>
              <Text strong>{formattedTime}</Text>
            </div>
            <div className="job-detail-header__property">
              <Text>Created by user:</Text>
              <Text strong>{props.job.userNameOrEmail}</Text>
            </div>
            <div className="job-detail-header__property">
              <Text>
                Status:{' '}
                <JobStatusTag
                  tooltipPlacement="bottom"
                  status={props.job.status}
                />
              </Text>
              <Text strong>
                <JobStatusMessage
                  status={props.job.status}
                  operationType={props.job.operationType}
                  summary={jobSummary}
                />
              </Text>
            </div>
          </div>
        </div>
      </div>
      {props.newOperationButton}
    </div>
  );
};

export default JobDetailHeader;
